const scrollUp = () => {
  window.scrollTo({ top: 200, left: 0, behavior: 'smooth' });
};

export default scrollUp;
